import { render, staticRenderFns } from "./Seconadmin.vue?vue&type=template&id=4bd7379c&scoped=true&"
import script from "./Seconadmin.vue?vue&type=script&lang=js&"
export * from "./Seconadmin.vue?vue&type=script&lang=js&"
import style0 from "./Seconadmin.vue?vue&type=style&index=0&id=4bd7379c&scoped=true&lang=css&"
import style1 from "./Seconadmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7379c",
  null
  
)

export default component.exports